const Base_url = (
  process.env.REACT_APP_API_URL || 'https://welcome-habibi-backend.vercel.app'
).replace(/\/$/, '');

export { Base_url };
export default Base_url;
